export default class FileUploader {
  constructor(element) {
    this.element = element;

    this.fileInput = this.element.querySelector(".js-file-upload-input");
    this.filePreviewer = this.element.querySelector(".js-file-upload-preview");
    this.fileNamePreview = this.element.querySelector(".js-file-upload-name");

    this.initialize();
  }

  initialize() {
    this.element.addEventListener("click", () => {
      this.fileInput.click();
    });

    this.fileInput.addEventListener("change", () => {
      this.previewFile();
    });
  }

  previewFile() {
    const file = this.fileInput.files[0];
    const reader = new FileReader();

    this.element.classList.toggle("has-file", file);

    if (!file) {
      this.filePreviewer.src = "";
      this.fileNamePreview.textContent = "";
      return;
    }

    if (file.type.startsWith("image/")) {
      reader.onloadend = () => {
        this.filePreviewer.src = reader.result;
      };
      reader.readAsDataURL(file);
    } else {
      this.filePreviewer.src = "";
    }

    this.fileNamePreview.textContent = file.name;
  }
}
